import Vue from "vue"
import { Challenge, defaultChallenge } from "./models/Challenge"
import { type Division } from "./models/Division"
import { BackEndService } from 'src/utils/BackEndService'
import { createSectionsFromMainPlayableJson } from "./utils/PlayableFactory"
import { playerConfig } from "../player/models/PlayerConfig"

interface ChallengeServiceState {
  searchValue: string
  currentChallenge: Challenge
  challengeDivisions: Division[],
}

class ChallengeService {

  public readonly state = Vue.observable<ChallengeServiceState>({
    searchValue: '',
    currentChallenge: defaultChallenge,
    challengeDivisions: [],
  })

  private currentLoadChallengePromise: Promise<void> | null = null
  private currentChallengeInPlayer: boolean | null = null
  public async loadChallenge(id: number, inPlayer = true) {
    if ((this.state.currentChallenge.id !== id || this.currentChallengeInPlayer !== inPlayer) && !this.currentLoadChallengePromise) {
      this.currentLoadChallengePromise = BackEndService.sendGetRequest(`challenge/${id}/sheet?inPlayer=${inPlayer}`).then((response) => {
        createSectionsFromMainPlayableJson(response.content.model)
        this.state.currentChallenge = Challenge.createFromChallengeJson(response.content.model);
        this.state.challengeDivisions = response.content.divisions
        playerConfig.setPlayerConfigState(this.state.currentChallenge.getPlayerConfig())
        this.currentChallengeInPlayer = inPlayer
      })
        .finally(() => {
          this.currentLoadChallengePromise = null
        })
    }

    if (this.currentLoadChallengePromise) {
      return this.currentLoadChallengePromise
    }

    playerConfig.setPlayerConfigState(this.state.currentChallenge.getPlayerConfig())

    return Promise.resolve()
  }

  public completeCurrentChallenge() {
    return BackEndService.sendPostRequest(`challenge/${this.state.currentChallenge.id}/complete`)
      .catch((e) => console.error(e));
  }

  public clearState() {
    this.state.currentChallenge = defaultChallenge
    this.state.challengeDivisions = []
  }

}


export const challengeService = new ChallengeService()
